import angular from 'angular';

import toolboxComponent from './toolbox.component';

export default angular.module('dbm.dashboard.components.toolbox', [])
.component('dbmToolbox', toolboxComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/toolbox/index.js